import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormControl, FormHelperText, FormLabel, Input } from "@mui/joy";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "../../src/css/AttorneyForm.css";
import { changeUsFormatNumber, validate } from "../components/Common";
import { inviteTenantUser } from "../services/user-service";
import {
  getExistSecondaryUserInvitationByEmail,
  getToken,
  inviteSecondaryUser,
  updateInviteSecondaryUser,
} from "../services/user-service";
import { EmailTemplateForInviteSecondaryUser } from "./Emailtemplate";
import axios from "axios";
import { Typography } from "@mui/material";

export default function JointAccount({ userId, onBack, mode }) {
  const [data, setData] = useState({
    userId: userId,
    secUserFirstName: "",
    secUserLastName: "",
    secUserEmail: "",
    phoneNo: "",
    street: "",
    city: "",
    zipCode: "",
    apartment: "",
    state: "",
    country: "",
     accountType: "",
  });

  const [emailDetail] = useState({
    to: "",
    subject: "",
    message: "",
  });

  const reset = () => {
    setData({
      userId: "",
      secUserFirstName: "",
      secUserLastName: "",
      secUserEmail: "",
      phoneNo: "",
      street: "",
      apartment: "",
      city: "",
      zipCode: "",
      state: "",
      country: "",
    });
  };

  const validatePhoneNumber = (phoneNo) => {
    if (phoneNo === "") {
      return true;
    }
    const re = /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/;
    return re.test(phoneNo);
  };

  const validateEmail = (secUserEmail) => {
    const re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    return re.test(secUserEmail);
  };

  const validateAlphanumeric = (value) => {
    return !/^\d+$/.test(value);
  };

  const validateZipCode = (zipCode) => {
    return /^\d{5}$/.test(zipCode);
  };

  const [errors, setErrors] = useState({
    secUserFirstName: true,
    secUserEmail: true,
    firstNameValidate: true,
    lastNameValidate: true,
    phoneValidate: true,
    emailValidate: true,
    zipValidate: true,
    validZip: true,
  });

  const handleChanges = (event, property) => {
    let value = event.target.value;
    const errorStates = { ...errors };

    if (property === "phoneNo") {
      const formattedValue = changeUsFormatNumber(value);
      setData((prevData) => ({
        ...prevData,
        [property]: formattedValue,
      }));
    } else if (property === "zipCode") {
      if (/^\d{0,5}$/.test(value)) {
        setData((prevData) => ({
          ...prevData,
          [property]: value,
        }));
      }
    } else {
      setData((prevData) => ({
        ...prevData,
        [property]: value,
      }));
      errorStates[property] = !!value;
    }
    if (property === "secUserEmail") {
      errorStates.emailValidate = validateEmail(value);
    } else if (property === "zipCode") {
      errorStates.zipValidate =
        value !== "" ? validateZipCode(value.slice(0, 5)) : true;
    } else if (property === "phoneNo") {
      errorStates.phoneValidate =
        value !== "" ? validatePhoneNumber(changeUsFormatNumber(value)) : true;
    } else if (
      property === "secUserFirstName" ||
      property === "secUserLastName"
    ) {
      if (property === "secUserFirstName") {
        errorStates.firstNameValidate = validateAlphanumeric(value);
      } else if (property === "secUserLastName") {
        if (value !== "") {
          errorStates.lastNameValidate = validateAlphanumeric(value);
        } else {
          errorStates.lastNameValidate = true;
        }
      }
    }
     setErrors(errorStates);
  };

  useEffect(() => {
    const fetchDataFromAPI = () => {
      if (data.zipCode.length === 5) {
        const apiUrl = `https://api.zippopotam.us/us/${data.zipCode}`;
        axios
          .get(apiUrl)
          .then((res) => {
            if (res.data && res.data.places && res.data.places.length > 0) {
              const place = res.data.places[0];
              const city = place["place name"];
              const state = place["state abbreviation"];
              const country = res.data["country abbreviation"];

              setData((prevData) => ({
                ...prevData,
                city: city,
                state: state,
                country: country,
              }));
              setErrors((prevErrors) => ({
                ...prevErrors,
                validZip: true,
              }));
            }
          })
          .catch((error) => {
            setErrors((prevErrors) => ({
              ...prevErrors,
              validZip: false,
            }));
          });
      } else {
        setData((prevData) => ({
          ...prevData,
          city: "",
          state: "",
          country: "",
        }));
        setErrors((prevErrors) => ({
          ...prevErrors,
          validZip: true,
        }));
      }
    };

    fetchDataFromAPI();
  }, [data.zipCode]);

  const submitForm = (event) => {
    event.preventDefault();
     const newErrors = {
      secUserFirstName: !!data.secUserFirstName,
      secUserEmail: !!data.secUserEmail,
      emailValidate: data.secUserEmail
        ? validateEmail(data.secUserEmail)
        : true,
      phoneValidate: data.phoneNo
        ? validatePhoneNumber(changeUsFormatNumber(data.phoneNo))
        : true,
      firstNameValidate: validateAlphanumeric(data.secUserFirstName),
      lastNameValidate: data.secUserLastName
        ? validateAlphanumeric(data.secUserLastName)
        : true,
      zipValidate: data.zipCode ? validateZipCode(data.zipCode) : true,
      validZip: errors.validZip,
    };
    setErrors(newErrors);
     const hasErrors = Object.values(newErrors).includes(false);

    if (!hasErrors) {
      emailDetail.to = data?.secUserEmail;
      emailDetail.message = EmailTemplateForInviteSecondaryUser(
        data.secUserFirstName,
        data.secUserLastName,
        mode === "orgUser" ? "org" : "secondary"
      );
      emailDetail.subject = mode === "orgUser" ? "ORGANIZATION USER INVITATION" : "SECONDARY USER INVITATION";

      if (mode === "orgUser") {
            data.accountType = "primary";
          } else {
            data.accountType = "secondary";
          }


      const formData = new FormData();

      formData.append("data", JSON.stringify(data));
      formData.append("emailData", JSON.stringify(emailDetail));

      if (mode === "orgUser") {
          data.userId = null;
          formData.append("tenantUser", "true");
      }

      const token = "Bearer " + getToken();

       getExistSecondaryUserInvitationByEmail(token, data.secUserEmail)
        .then((res) => {
          if (res !== false) {
             updateInviteSecondaryUser(token, formData)
              .then((res) => {
                toast.success("Invitation link resent successfully.", {
                  position: toast.POSITION.BOTTOM_CENTER,
                });
                onBack();
              })
              .catch((error) => {
                toast.error("Error during invitation", {
                  position: toast.POSITION.BOTTOM_CENTER,
                });
              });
          } else {
              if (mode === "orgUser") {
                             inviteTenantUser(token, formData)
                               .then(() => {
                                 toast.success("Organization user invitation sent successfully.", {
                                   position: toast.POSITION.BOTTOM_CENTER,
                                 });
                                 onBack();
                               })
                               .catch(() => {
                                 toast.error("Error sending organization user invitation", {
                                   position: toast.POSITION.BOTTOM_CENTER,
                                 });
                               });

              } else {
                inviteSecondaryUser(token, formData)
                  .then(() => {
                    toast.success("Invitation link sent successfully.", {
                      position: toast.POSITION.BOTTOM_CENTER,
                    });
                    onBack();
                  })
                  .catch(() => {
                    toast.error("Error sending secondary user invitation", {
                      position: toast.POSITION.BOTTOM_CENTER,
                    });
                  });
              }

          }
        })
        .catch((error) => {
          toast.error("Error checking existing secondary user invitation", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        });
    }
  };

  return (
    <>
      <div className="joint_registration_container">
        <div className="joint_registration_form">
          <div className="joint_registration_form_heading">
              <h1 style={{ textAlign: "center", width: "100%" }}>
                {mode === "orgUser" ? "Organization User Account" : "Secondary Account"}
            </h1>
            <div className="joint_registration_cancel_icon">
              <FontAwesomeIcon icon={faTimes} onClick={onBack} />
            </div>
          </div>
          <form className="joint_registration_form_main" onSubmit={submitForm}>
            <div className="joint_account_form">
              <div className="joint_form_left">
                <FormControl>
                  <FormLabel required>First Name</FormLabel>
                  <Input
                    placeholder="Enter first name"
                    value={data.secUserFirstName}
                    onChange={(e) => handleChanges(e, "secUserFirstName")}
                  />
                  {(!errors.secUserFirstName || !errors.firstNameValidate) && (
                    <FormHelperText error>
                      <Typography variant="caption" color="error">
                        {!errors.secUserFirstName
                          ? "First Name is required"
                          : !errors.firstNameValidate
                          ? "Enter valid first name"
                          : ""}
                      </Typography>
                    </FormHelperText>
                  )}
                </FormControl>

                <FormControl>
                  <FormLabel>Last Name</FormLabel>
                  <Input
                    placeholder="Enter last name"
                    value={data.secUserLastName}
                    onChange={(e) => handleChanges(e, "secUserLastName")}
                  />
                  {!errors.lastNameValidate && (
                    <FormHelperText error>
                      <Typography variant="caption" color="error">
                        {!errors.lastNameValidate
                          ? "Enter valid last name"
                          : ""}
                      </Typography>
                    </FormHelperText>
                  )}
                </FormControl>

                <FormControl>
                  <FormLabel required>Email</FormLabel>
                  <Input
                    placeholder="Enter email address"
                    value={data.secUserEmail}
                    onChange={(e) => handleChanges(e, "secUserEmail")}
                  />
                  {(!errors.secUserEmail || !errors.emailValidate) && (
                    <FormHelperText error>
                      <Typography variant="caption" color="error">
                        {!errors.secUserEmail
                          ? "Email is required"
                          : !errors.emailValidate
                          ? "Enter a valid email"
                          : ""}
                      </Typography>
                    </FormHelperText>
                  )}
                </FormControl>
                <FormControl>
                  <FormLabel>Phone Number</FormLabel>
                  <Input
                    placeholder="Enter phone number"
                    value={data.phoneNo}
                    onChange={(e) => handleChanges(e, "phoneNo")}
                  />
                  {!errors.phoneValidate && (
                    <FormHelperText error>
                      <Typography variant="caption" color="error">
                        {!errors.phoneValidate
                          ? "Enter a valid phone number"
                          : ""}
                      </Typography>
                    </FormHelperText>
                  )}
                </FormControl>
                <FormControl className="bene_input_form">
                  <FormLabel>Street</FormLabel>
                  <Input
                    placeholder="Enter street"
                    value={data.street}
                    onChange={(e) => handleChanges(e, "street")}
                  />
                </FormControl>
                <FormControl className="bene_input_form">
                  <FormLabel>Apartment</FormLabel>
                  <Input
                    placeholder="Enter street"
                    value={data.apartment}
                    onChange={(e) => handleChanges(e, "apartment")}
                  />
                </FormControl>

                <div className="bene_address">
                  <div className="bene_address_half">
                    <FormControl className="bene_input_form">
                      <FormLabel>Zip Code</FormLabel>
                      <Input
                        placeholder="Enter zip code"
                        value={data.zipCode}
                        onChange={(e) => handleChanges(e, "zipCode")}
                      />
                      {(!errors.zipValidate || !errors.validZip) && (
                        <FormHelperText error>
                          <Typography variant="caption" color="error">
                            {!errors.zipValidate
                              ? "Please enter a valid 5-digit Zip Code"
                              : !errors.validZip
                              ? "This is not a valid Zip Code"
                              : ""}
                          </Typography>
                        </FormHelperText>
                      )}
                    </FormControl>
                  </div>
                  <div className="bene_address_half">
                    <FormControl className="bene_input_form">
                      <FormLabel>City</FormLabel>
                      <Input
                        placeholder="Enter city"
                        value={data.city}
                        disabled
                        readOnly
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="bene_address">
                  <div className="bene_address_half">
                    <FormControl className="bene_input_form">
                      <FormLabel>State</FormLabel>
                      <Input
                        placeholder="Enter state"
                        value={data.state}
                        disabled
                        readOnly
                      />
                    </FormControl>
                  </div>
                  <div className="bene_address_half">
                    <FormControl className="bene_input_form">
                      <FormLabel>Country</FormLabel>
                      <Input
                        placeholder="Enter country"
                        value={data.country}
                        disabled
                        readOnly
                      />
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
            <div className="joint_form_btn_main">
              <div className="joint_form_btn">
                <button onClick={reset} type="button">
                  Clear
                </button>
              </div>
              <div className="joint_form_btn">
                <button type="submit">Invite</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}